import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/LogoShowcaseSection.css';
import fullLogo from '../../../assets/images/Logo/full-logo.png';

const CAPABILITIES = ['24/7 Monitoring', 'Adaptive Response', 'Precision Execution'];

const LogoShowcaseSection = () => {
  const navigate = useNavigate();
  return (
    <section className="logo-showcase">
      <div className="logo-showcase__grid-bg" aria-hidden="true"></div>
      <div className="logo-showcase__glow logo-showcase__glow--one" aria-hidden="true"></div>
      <div className="logo-showcase__glow logo-showcase__glow--two" aria-hidden="true"></div>

      <div className="logo-showcase__container">
        {/* Left Side - Logo on a radar scope */}
        <div className="logo-showcase__logo-side">
          <div className="radar">
            <span className="radar-ring r1" aria-hidden="true" />
            <span className="radar-ring r2" aria-hidden="true" />
            <span className="radar-ring r3" aria-hidden="true" />
            <span className="radar-crosshair radar-crosshair--v" aria-hidden="true" />
            <span className="radar-crosshair radar-crosshair--h" aria-hidden="true" />
            <span className="radar-beam" aria-hidden="true" />
            <img
              src={fullLogo}
              alt="ALG Data Guard Logo"
              className="logo-showcase__logo-image"
            />

            <span className="scan-corner tl" aria-hidden="true" />
            <span className="scan-corner tr" aria-hidden="true" />
            <span className="scan-corner bl" aria-hidden="true" />
            <span className="scan-corner br" aria-hidden="true" />
          </div>

          <span className="radar-status">
            <span className="live-dot" aria-hidden="true" />
            Monitoring active
          </span>
        </div>

        {/* Right Side - Content */}
        <div className="logo-showcase__content-side">
          <div className="logo-showcase__eyebrow">
            <span className="live-dot" aria-hidden="true" />
            Coverage overview
          </div>

          <h2 className="logo-showcase__title">
            Wide breadth. Precision focus.
          </h2>

          <p className="logo-showcase__description">
            Our expertise runs the gamut of mission critical services. We keep a watchful eye on the broad and complex landscape of your unique business needs, always deploying the right tactics at the right times for the most effective outcome.
          </p>

          <ul className="logo-showcase__capabilities">
            {CAPABILITIES.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>

          <button className="logo-showcase__cta" onClick={() => navigate('/services')}>
            Our Services
            <svg
              className="logo-showcase__cta-arrow"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M5 12h14M13 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default LogoShowcaseSection;
